export enum REACTIONS_LIKES {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=59685966
     */
    LIKE_BUTTON_ARIA = 'FRONT.CONTENTS.LIKE_BUTTON.ARIA',
}
